import React from "react";
import {
  LeftOutlined,
  CalendarOutlined,
  HomeOutlined,
  UserOutlined,
  LaptopOutlined,
  ReloadOutlined
} from "@ant-design/icons";
import { Skeleton, Layout, message, theme, ConfigProvider, Image } from "antd";
import { getCurrentShopId } from "./pages/shop/get-current-shop";
import zhCN from 'antd/es/locale/zh_CN';
import "./App.css";
import { SafeStorage } from './utils/webview';
import { detectWebView } from './utils/webview';

const { Header, Content, Sider, Footer } = Layout;
const {isWebView} = detectWebView();

const ignorePath = [
  '/logout',
  '/login',
  '/regist',
  '/regist2',
  '/waiting',
];
const App = (props) => {
  const [loading, setLoading] = React.useState(true);
  const [userAbility, setUserAbility] = React.useState();
  const [currentShopId, setCurrentShopId] = React.useState();

  React.useEffect(() => {
    const fetchCurrentShopId = async () => {
      const shopId = await getCurrentShopId();
      setCurrentShopId(shopId);
    };
    
    fetchCurrentShopId();
  }, []);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const getUserAblity = async () => { 
    console.log('Fetching user ability from API');
    const response = await fetch(`/api/account/user-permission?shopId=${currentShopId}`);
    const result = await response.json();
    console.log('User ability API response:', result);

    if(result && result.success) {
      await SafeStorage.setItem('user-ability', JSON.stringify(result.data), true);
      console.log('User ability saved to sessionStorage');
      return result.data;
    }

    console.log('Failed to fetch user ability');
    return []
  };

  React.useEffect(() => {
    SafeStorage.getItem('user-ability', true).then(stored => {
      if(!stored) {
        getUserAblity().then((res) => {
          setUserAbility(res);
          setLoading(false);
        }).catch(() => {
          setLoading(false);
        }).finally(() => {
          setLoading(false);
        });
      } else {
        try {
          const parsed = JSON.parse(stored);
          setUserAbility(parsed);
        } catch (e) {
          console.error('Failed to parse stored user ability:', e);
        }
        setLoading(false);
      }
    });
  }, []);

  return (
    <ConfigProvider locale={zhCN} theme={{ 
      token: { 
        colorPrimary: "#00b96b", 
        // colorBorderSecondary: "#d9d9d9" 
      },
      components: {
        Form: {
          verticalLabelPadding: "0 0 0 0",
          itemMarginBottom: '10px',
        },
        Table: {
          headerBorderRadius: 0,
        },
        Card: {
          bodyPadding: '12px'
        },
        Menu: {
          itemBg: 'rgba(0, 0, 0, 0.04)'
        }
      }
    }}>
      <Layout style={{ height: "100%", justifyContent: 'space-between' }}>
        {/* <div id='refresh-msg' style={{ zIndex: 100, position: 'absolute', color: 'green', width: '100%', height: '20px', overflow: 'hidden', display: 'none', 'textAlign': 'center'}}>刷新?</div> */}
        {window.__baseInfo.noHeader !== true && <Header
          style={{
            display: "flex",
            alignItems: "flex-end",
            position: "fixed",
            zIndex: 1000,
            width: "100%",
            justifyContent: "space-between",
            padding: "0 0",
            lineHeight: "40px",
            height: (isWebView ? "80px" : "40px"),
            background: "#0a4a86",
          }}
        >
          <div
            className="demo-logo"
            style={{ paddingLeft: '10px', fontWeight: 'bold', color: "white", display: "flex", alignItems: "center" }}
          >
            <LeftOutlined style={{fontSize: '22px', color: 'white', padding: '0 10px 0 0'}} onClick={() => {
              // 后退
              window.history.back();
            }} />

            <ReloadOutlined style={{fontSize: '22px', color: 'white', padding: '0 10px 0 0'}} onClick={() => {
              // 刷新
              window.location.reload();
            }} />
            
            <img style={{margin: '0 6px 0 0', borderRadius: '6px'}} width={30} height={30} src="https://img.yxdj.tech/yxdj-system/logo.png?x-oss-process=image/resize,w_60" />
            
            优选到家系统
          </div>
          <div
            className="user-logout"
            style={{
              color: "white",
              marginRight: "10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {window.__baseInfo.username}
          </div>
        </Header>}
        <Layout style={{flexGrow: 1}}>
          <Content
            style={{
              padding: '50px 10px 10px 10px',
              paddingTop: (isWebView ? "90px" : "50px"),
              margin: 0,
              minHeight: 480,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            <div>{loading ? <Skeleton rows={10} /> : props.children}</div>
          </Content>
        </Layout>
        <Footer style={{ textAlign: "center", background: '#fff' }}>
          &nbsp;
        </Footer>
      </Layout>
      {window.__baseInfo.noFooter !== true && !ignorePath.includes(window.location.pathname) && <nav style={{position: 'fixed', display:'flex', zIndex: 1000, width: '100%', bottom: 0, height: '70px', borderTop: '1px solid #dfdfdf', background: '#fff', paddingBottom: 'env(safe-area-inset-bottom)'}}>
          <a href="/index" style={{flexGrow: 1, fontSize: 14, padding: '15px 0', textAlign: 'center'}}>
            <HomeOutlined style={{fontSize: 20}} />
            <div>首页</div>
          </a>
          {(window.__baseInfo.userId === '154955145316' || window.__baseInfo.userId === '565585262612') && <a href="/sys" style={{flexGrow: 1, fontSize: 14, padding: '15px 0', textAlign: 'center'}}>
            <LaptopOutlined style={{fontSize: 20}} />
            <div>系统首页</div>
          </a>}
          <a href="/schedule" style={{flexGrow: 1, fontSize: 14, padding: '15px 0', textAlign: 'center'}}>
            <CalendarOutlined style={{fontSize: 20}} />
            <div>日程</div>
          </a>
          <a href="/my" style={{flexGrow: 1, fontSize: 14, padding: '15px 0', textAlign: 'center'}}>
            <UserOutlined style={{fontSize: 20}} />
            <div>我的</div>
          </a>
      </nav>}
    </ConfigProvider>
  );
};

export default App;
